import Vue from 'vue/dist/vue.js';
import smoothscroll from 'smoothscroll-polyfill';
export default {
    _progress : null,

    init() {
        this._progress = document.querySelector('#fiberProgress');
        if (!this._progress) {
            return;
        }
        new Vue({
            el        : this._progress,
            delimiters: ['[[', ']]'],
            data: {
                progressList:         [],
                commune: 'Velg kommune',
                area:'Velg område',
                report: null,
            },
            created() {
                this.getQueryParamValues();
                this.getProgressList(); 
              //  this.renderReport();
              
            },
            methods: {
                getQueryParamValues() {
                    const params =window.location.href;
                    const areaString = params.split('#')[1];
                    if(areaString !== undefined){
                        this.area = areaString;
                        this.commune = this.progressList.commune;
                    }
                },
                getProgressList() {
                    const xhr = new XMLHttpRequest();
                    if(this.commune != "Velg kommune" || this.area != "Velg område" ){
                        params = `commune=${this.commune}&area=${this.area}`;
                    }
                    xhr.onload = () => {
                        if (xhr.responseText) {
                            const result = JSON.parse(xhr.responseText);
                            this.progressList = result;
                            this.commune = this.progressList.commune;
                            this.area = this.progressList.area;
                            let reportActive = document.querySelector("[data-regions-report='" +this.area +"']");
                            if(reportActive){
                                reportActive.classList.add(reportActive.classList[0]+'--active');
                                reportActive.getElementsByClassName('fiberprogress__report-heading')[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                                let focused = reportActive.querySelector('.focus');
                                if(screen.width < 500){
                                    focused.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
                                }
                            }
                        } else {
                            console.error('ERROR: Could not GET progressList');
                        }
                    }
                    let params =`commune=Velg kommune&area=Velg område`;
                    if(this.commune != "Velg kommune" || this.area != "Velg område" ){
                        params = `commune=${this.commune}&area=${this.area}`;
                    }
                    xhr.open('get', '/actions/istad/istadfiber/progress?'+params);
                    xhr.send();
                },
                toggleDropdown(elm){
                    let target = document.querySelector('#'+elm);
                    let targetClass = target.classList[0]+'--active';
                    target.classList.toggle(targetClass);
                },
                updateCommune(el) {
                    this.commune = el.target.innerHTML.trim();
                    let target = document.querySelector('#fiberprogresstarget');
                    target.classList.toggle('fiberprogress__dropdown--active');
                    let regionDropdown = document.querySelector('#fiberRegions');
                    regionDropdown.classList.remove('fiberprogress__dropdown--active');
                    this.updateReport();
                    this.resetAreaParam();
                    this.getProgressList(); 

                },
                updateArea(el) {
                    this.area = el.target.innerHTML.trim();
                    this.queryParamsHandler();
                    let target = document.querySelector('#fiberRegions');
                    target.classList.toggle('fiberprogress__dropdown--active');
                    this.updateReport();
                    const reportRefer = el.target.getAttribute('data-region');
                    let reportActive = document.querySelector("[data-regions-report='" +reportRefer +"']");
                    reportActive.classList.add(reportActive.classList[0]+'--active');
                    reportActive.getElementsByClassName('fiberprogress__report-heading')[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    let focused = reportActive.querySelector('.focus');
                    if(screen.width < 500){
                        focused.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
                    }
                },
                updateReport(){
                    let reportBlocks = document.querySelectorAll("[data-regions-report]");
                    for(const block of reportBlocks ){
                        block.classList.remove(block.classList[0]+'--active');
                    }
                },

             
                queryParamsHandler() {
                    let queryParams = '';
                    const origin = window.location.origin;
                    const pathname = window.location.pathname;
                    let url = origin + pathname;
                    let areaString = this.area.replace(/[, ]+/g, "-").trim();
                    areaString = areaString.replace('æ', "aa");
                    areaString = areaString.replace('ø', "o");
                    areaString = areaString.replace('å', "o");
                    
                    if (this.area != "Velg område") queryParams += `#${areaString}`;
                    if (queryParams !== '') {
                        url += queryParams;
                    }
                    history.replaceState({}, null, url);
                },

                resetAreaParam() {
                    this.area = "Velg område";
                    let url = window.location.href;
                    history.replaceState({}, null, url);
                },
                sortFunction(a, b) {
                    if (a[1] === b[1]) {
                        return 0;
                    }
                    else {
                        return (a[1] < b[1]) ? -1 : 1;
                    }
                }
            },

            computed: {
                communes: {
                    get() { return this.progressList.communes; },
                    set(value){this.value = value}
                },
                areaList: {
                    get() { return this.progressList.areaList; },
                    set(value){this.value = value}
                },
               
            },
            watch: {
                commune: function() {
                },
                area: function() {
                }
            }
    })

    }
}